import React, { useEffect, useState } from "react"

// Gatsby
import { useStaticQuery, graphql, navigate } from "gatsby"
import Img from "gatsby-image"


// Components
// import LargeArticle from '../articles/large'
import MediumArticle from '../articles/medium'

// Libs
import slugify from 'slugify'

const News = () => {
  const [news, setNews] = useState(null)
  const [mainStory, setMainStory] = useState(null)
  const [recentNews, setRecentNews] = useState(null)

  const data = useStaticQuery(graphql`
    query NewsArticles {
      all: allStrapiArticle(filter: { category: { eq: "todos" } }) {
        nodes {
          strapiId
          title
          intro
          category
          author {
            name
          }
          date(fromNow: true)
          image {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      recent: allStrapiArticle(filter: { category: { eq: "actualidad" } }) {
        nodes {
          strapiId
          title
          category
          intro
          author {
            name
          }
          date(fromNow: true)
          image {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
`)

  useEffect(() => {
    if (data && data.all?.nodes && !news) {
      setNews(data.all.nodes)
    }
    if (data && data.recent?.nodes && (!mainStory || !recentNews)) {
      setMainStory(data.recent.nodes[0])
      setRecentNews(data.recent.nodes.slice(1))
    }
  }, [data])

  return (
    // <section id="main" className="grid grid-cols-12 px-16 py-10 lg:mt-0 pt-64 lg:pt-10 gap-2 lg:gap-20"></section>
    <section id="main" className="grid grid-cols-12 px-4 md:px-16 bg-gray-200 py-10 lg:pt-20 pt-64 gap-2 lg:gap-20">
      <h1 className="col-span-12 mx-auto text-3xl tracking-wider mt-32">Blog</h1>
      {mainStory && (
        <div className="col-span-12 lg:col-span-6 cursor-pointer" onClick={() => navigate(`/blog/${slugify(mainStory.title)}`)}>
          <Img fluid={mainStory.image.childImageSharp.fluid} />
          <div className="bg-white mb-2 p-5">
            <h1 className="inline-block leading-tight lg:leading-snug text-left my-3 text-xl lg:text-3xl font-bold"> {mainStory.title} </h1>
            <p className="text-left lg:text-base mb-2 lg:mb-3 font-light text-main_color"> {mainStory.category.toUpperCase()} | {mainStory.date} </p>
            <p className="text-left leading-snug font-light text-sm lg:text-lg mb-10 lg:mb-0"> {mainStory.intro}
            </p>
          </div>
        </div>
      )}
      <div className="col-span-12 lg:col-start-7 lg:col-span-6">
        <div className="grid grid-cols-12">
          {news && news.map(n => (
            <MediumArticle key={n.strapiId} article={n} />
          ))}
        </div>
      </div>
      <div className="col-span-12 lg:col-span-6 text-3xl lg:-mb-3 text-gray-900 md:mt-0 mt-16">ACTUALIDAD</div>
      <div className="col-span-12 lg:col-start-1 lg:col-span-8">
        <div className="grid grid-cols-12">
          {recentNews && recentNews.map(r => (
            <MediumArticle key={r.strapiId} article={r} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default News